import { Box, LinearProgress } from '@mui/material'
import { useContext } from 'react'
import { AppContext } from '../context/app/AppContext'

export const Loader = () => {
	const { useAppState } = useContext(AppContext)
	const state: any = useAppState()

	return (
		<Box sx={{ position: 'absolute', top: 0, width: '100%', zIndex: 1101 }}>
			{state?.loading && <LinearProgress />}
		</Box>
	)
}
